const mrbDefaultFormats = {
    date: "date",
    bool: "bool",
    currency: "currency",
};

export default mrbDefaultFormats;
